import { render, staticRenderFns } from "./studyStaff.vue?vue&type=template&id=0e7ec2e8&"
import script from "./studyStaff.vue?vue&type=script&lang=js&"
export * from "./studyStaff.vue?vue&type=script&lang=js&"
import style0 from "./studyStaff.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports